// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = 'https://api.fastfin.com'; // Replace with actual API URL

export const fetchUserProfile = createAsyncThunk(
  'user/fetchUserProfile',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'user/updateUserProfile',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/users/${userData.id}`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchLoanHistory = createAsyncThunk(
  'user/fetchLoanHistory',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${userId}/loans`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    name: '',
    panNumber:'',
    aadharNumber:'',
    phoneNumber:'',
    isOtpVerified:false,
    token:'',
    isAuthenticated: false,
    bankDetails: [],
    loanHistory: [],
    address:'',
    pinCode:'',
    email:'',
    openLoginModal: false,
    openSignupModal: false,
    openKYCModal: false,  
  },
 
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setUserData: (state, action) => {
    return {...state,...action.payload}
    },
    setOpenLoginModal: (state, action) => {
      state.openLoginModal = action.payload;
    },
    setOpenSignUpModal: (state, action) => {
      state.openSignupModal = action.payload;
    },
    setOpenKYCModal: (state, action) => {
      state.openKYCModal = action.payload;
    },
    logout: (state) => {
      state.profile = null;
      state.loanHistory = [];
      state.isAuthenticated = false;
    },
  }
});

export const { setAuthenticated, logout,setUserData, setOpenLoginModal, setOpenSignUpModal, setOpenKYCModal } = userSlice.actions;
export default userSlice.reducer;